import { Component, OnInit, ViewEncapsulation, Input, HostBinding, Output, EventEmitter } from '@angular/core';
import { IdService } from '../../../shared/services/id.service';
import { Locale, Column } from '../datatable.models';
import { guid } from '../../../shared/utils/generic';
import { IGenericSelectOption } from '../../../shared/types/forms';

interface IFilteredColumn extends IGenericSelectOption, Column {}

@Component({
	selector: 'rbc-datatable-column-filter',
	templateUrl: './datatable-column-filter.component.html',
	styleUrls: ['./datatable-column-filter.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class DatatableColumnFilterComponent implements OnInit {
	@HostBinding('class') @Input('class') classList: string = '';
	@Input() id: string;
	@Input() locale: Locale;
	_columns: Column[];
	@Input()
	set columns(cols: Column[]) {
		this._columns = cols;
		this.filteredColumns = this.extendColumns(cols);
	}
	get columns(): Column[] {
		return this._columns;
	}

	@Output('oncolumnfiltercheckboxupdated') onColumnFilterCheckboxUpdated = new EventEmitter<Column[]>();
	filteredColumns: IFilteredColumn[] = [];
	columnsChecked: IFilteredColumn[] = []; // filteredColumns' state, managed by the multiselect
	selectedColumns: Column[];
	open = false;
	defaultSelectionText = 'Choose ...';

	constructor(private idService: IdService) {}

	ngOnInit() {
		if (!this.id) {
			this.id = this.idService.generate();
		}
		this.classList = [this.classList, 'datatable-columnfilter'].filter(c => !!c).join(' ');
		if (this.columns && this.columns.length) {
			this.selectedColumns = this.columns.filter(c => c.show);
		}
	}

	// prepare columns for use in multi-select
	extendColumns(cols: Column[]): IFilteredColumn[] {
		return cols.map(col => {
			return {
				id: guid(),
				label: col.header,
				value: col.header,
				disabled: col.isMandatory,
				selected: col.show,
				...col
			};
		});
	}

	onMultiselectUpdate(multiselectEvent: IFilteredColumn[]) {
		if (!this.columnsChecked || !this.columnsChecked.length) {
			this.columnsChecked = multiselectEvent;
		}
		// Current selected columns. the property of "show" set to true.
		this.selectedColumns = this.columnsChecked.reduce(
			(allCols, thisCol) => {
				if (thisCol.selected) {
					const thisColCopy = { ...thisCol };
					delete thisColCopy.id;
					delete thisColCopy.label;
					delete thisColCopy.value;
					delete thisColCopy.selected;
					delete thisColCopy.disabled;
					allCols.push(thisColCopy);
				}
				return allCols;
			},
			[] as Column[]
		);

		if (this.columnsChecked && this.columnsChecked.length) {
			// mutate the columns prop in the Table parent to match 'show' with the model result of the selected key
			this.columnsChecked.forEach((col, i) => {
				this.filteredColumns[i].show = col.selected;
			});
		}

		// emit only the select columns
		this.onColumnFilterCheckboxUpdated.emit(this.selectedColumns);
	}
}
